import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {

  };
}

const state = initialState ();

// actions

const actions = {
  async markSeatsLocked (context, payload) {
    var response = await API.bookings.markSeatsLocked (payload);
    return response;
  },
  async bookSeats (context, payload) {
    var response = await API.bookings.bookSeats (payload);
    return response;
  },

  async submitBookingQuery (context, payload) {
    var response = await API.bookings.submitBookingQuery (payload);
    return response;
  },

  async getLockedBooking (context, payload) {
    var response = await API.bookings.submitBookingQuery (payload);
    return response;
  }
};

// getters
const getters = {
  getField
};

// mutations
const mutations = {
  updateField,
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
